<template>
<transition name="fade">
  <div class="hello1" v-if="showPreloaderMini">
      <div class="preloadermini">
         <div class="loader-containermini">
            <p><img src="/img/pizza.gif" width="100" alt="" ></p>
            <p style="margin-top: -5px; animation: 1s ease-out 0s 1 slideInFromLeft;">Loading... Please Wait</p>
         </div>
      </div>
  </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'PreLoaderMini',
  computed: {
    ...mapGetters(["showPreloaderMini"]),
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
